import * as Yup from "yup";

export const rideSchema = Yup.object().shape({
  id: Yup.string().nullable(),
  rider: Yup.object().shape({
    firstName: Yup.string().nullable(),
    lastName: Yup.string().nullable(),
  }),
  pickup: Yup.object().shape({
    address: Yup.object().shape({
      addressLine1: Yup.string().nullable(),
      addressLine2: Yup.string().nullable(),
      city: Yup.string().nullable(),
      state: Yup.string().nullable(),
      zipCode: Yup.string().nullable(),
    }),
    scheduledTime: Yup.string().nullable(),
  }),
  dropoff: Yup.object().shape({
    address: Yup.object().shape({
      addressLine1: Yup.string().nullable(),
      addressLine2: Yup.string().nullable(),
      city: Yup.string().nullable(),
      state: Yup.string().nullable(),
      zipCode: Yup.string().nullable(),
    }),
    scheduledTime: Yup.string().nullable(),
  }),
  appointmentTime: Yup.string().nullable(),
  billableAmount: Yup.number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .nullable()
    .min(0, "Amount cannot be less than 0")
    .typeError("Billable Amount must be a number"),
  billableMiles: Yup.number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .nullable()
    .typeError("Billable Miles must be a number"),
  // billingRequired: Yup.boolean(),
  levelOfService: Yup.string().nullable(),
  willCall: Yup.boolean(),
  transportationProviderId: Yup.string().nullable(),
  // webhookURL: Yup.string().url("Must be a valid URL").nullable(),
});
